import onAccept from './on-accept';
import onRevoke from './on-revoke';
import { COOKIES } from './constants';

export { onAccept, onRevoke, COOKIES };
